import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import {
    NUMBER_OF_OWNERS_DROPDOWN_ITEMS,
    OWNERS_PRACTICE,
} from './../../utils/practiceProfileConstants';
import Helpers from '../../utils/helper';
import './PracticeProfileFields.scss';
import PracticeLocationItem from './PracticeLocationItem';
import { UserSummaryPracticeDTO } from './practiceDataMapper';
import { useServiceFocuses } from '../../custom-hooks/useServiceFocuses';
import { isOtherFocus } from '../UserPages/Login/Modals/PracticeRegistrationForm/utils';

interface PracticeProfileFieldsProps {
    practice: UserSummaryPracticeDTO;
}

const PracticeProfileFields: React.FC<PracticeProfileFieldsProps> = (props) => {
    const serviceFocuses = useServiceFocuses();
    const nameField = (
        <FormGroup>
            <Label for="name">Practice Name</Label>
            <h6>{props.practice.name}</h6>
        </FormGroup>
    );

    const phoneField = (
        <FormGroup>
            <Label for="name">Practice Phone</Label>
            <h6>
                {Helpers.getFormattedPhoneNumberWithoutPrefix(
                    props.practice.principalOwnerPhone
                )}
            </h6>
        </FormGroup>
    );

    const websiteField = (
        <FormGroup>
            <Label for="name">Website</Label>
            <h6>{props.practice.website}</h6>
        </FormGroup>
    );

    const numberOfOwnersField = (
        <FormGroup>
            <Label for="name">Number of Owners:</Label>
            <h6>
                {
                    NUMBER_OF_OWNERS_DROPDOWN_ITEMS.find(
                        (item) => item.id === props.practice.noofOwners
                    )?.name
                }
            </h6>
        </FormGroup>
    );

    const ownedPracticeSinceField = (
        <FormGroup>
            <Label for="name">Owned Since</Label>
            <h6>{props.practice.ownedPracticeSince || 'Not specified'}</h6>
        </FormGroup>
    );

    const ownersPracticeField = (
        <FormGroup>
            <Label for="name">Owner Actively Practicing at Practice</Label>
            <h6>
                {OWNERS_PRACTICE.find(
                    (item) => item.key === props.practice.ownersPractice
                )?.name || 'Not specified'}
            </h6>
        </FormGroup>
    );

    const numberOfLocationsField = (
        <FormGroup>
            <Label for="name">Number of Locations:</Label>
            <h6>{props.practice.practiceLocationData?.length || 0}</h6>
        </FormGroup>
    );

    const practiceFocusField = (
        <FormGroup>
            <Label for="name">Service Focus:</Label>
            <h6>
                {isOtherFocus(serviceFocuses, props.practice.practiseTypeID)
                    ? props.practice.otherPracticeType ||
                      serviceFocuses.find((item) =>
                          isOtherFocus(serviceFocuses, item.id)
                      )?.name ||
                      ''
                    : serviceFocuses.find(
                          (item) => item.id === props.practice.practiseTypeID
                      )?.name || 'Not specified'}
            </h6>
        </FormGroup>
    );

    const numberOfFteDvmsField = (
        <FormGroup>
            <Label for="name">Number of FTE DVMs</Label>
            <h6>
                {props.practice.practiceFteDvmNumber !== undefined &&
                props.practice.practiceFteDvmNumber !== null
                    ? Helpers.getFteDvmsRange().find(
                          (item) =>
                              item.id === props.practice.practiceFteDvmNumber
                      )?.name || props.practice.practiceFteDvmNumber
                    : 'Not specified'}
            </h6>
        </FormGroup>
    );

    const ltmRevenueField = (
        <FormGroup>
            <Label for="name">LTM Revenue:</Label>
            <h6>
                {props.practice.ltmRevenue
                    ? Helpers.GetCurrencyFormat(
                          props.practice.ltmRevenue,
                          0,
                          false
                      )
                    : 'Not specified'}
            </h6>
        </FormGroup>
    );

    const locationsSection = () => (
        <>
            {props.practice.practiceLocationData &&
                props.practice.practiceLocationData.length > 0 && (
                    <div
                        className="locations-section"
                        style={{ marginTop: '1rem' }}>
                        {props.practice.practiceLocationData.map(
                            (location, index) => (
                                <PracticeLocationItem
                                    key={`location-${index}`}
                                    practiceLocationData={location}
                                    index={index}
                                    isEditMode={false}
                                    allStates={[]}
                                    fteDvmsRange={[]}
                                />
                            )
                        )}
                    </div>
                )}
        </>
    );

    return (
        <div className="practice-profile-fields">
            <>
                <Row>
                    <Col md={12}>{nameField}</Col>
                </Row>
                <Row>
                    <Col md={6}>{phoneField}</Col>
                    <Col md={6}>{websiteField}</Col>
                </Row>
                <Row>
                    <Col md={6}>{numberOfOwnersField}</Col>
                    <Col md={6}>{ownersPracticeField}</Col>
                </Row>
                <Row>
                    <Col md={6}>{ltmRevenueField}</Col>
                    <Col md={6}>{numberOfFteDvmsField}</Col>
                </Row>
                <Row>
                    <Col md={6}>{numberOfLocationsField}</Col>
                    <Col md={6}>{ownedPracticeSinceField}</Col>
                </Row>
                <Row>
                    <Col md={6}>{practiceFocusField}</Col>
                </Row>

                {locationsSection()}
            </>
        </div>
    );
};
export default PracticeProfileFields;
